import { TB_LIST, TB_LIST_MOVIE, TB_MOVIE } from "../config";
import { supabase } from "./supabase";

const getAllLists = async () => {
  const { data, error } = await supabase
    .from(TB_LIST)
    .select("*")
    .order("lid", { ascending: true });

  if (error) {
    console.error("Error fetching all lists:", error.message);
    throw error;
  }

  return data;
};

const getListDetail = async (listId) => {
  const { data, error } = await supabase
    .from(TB_LIST)
    .select(
      `
      lid,
      title,
      description,
      ${TB_LIST_MOVIE} (
        id,
        rank,
        description,
        ${TB_MOVIE} (
          mid,
          title,
          poster
        )
      )
    `,
    )
    .eq("lid", listId)
    .order("rank", { foreignTable: TB_LIST_MOVIE, ascending: false })
    .single();

  if (error) throw error;

  const list = data;
  if (!list) return [];

  // Flatten
  const flatMoviesList = list.list_movie.map((lm) => ({
    title: lm.movie.title,
    rank: lm.rank,
    description: lm.description,
    mid: lm.movie.mid,
    poster: lm.movie.poster,
  }));

  const result = {
    title: list.title,
    description: list.description,
    moviesList: flatMoviesList,
  };

  return result;
};

export { getAllLists, getListDetail };
